export default "__VITE_ASSET__BH4f06RG__"